/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import axios, { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
// reactstrap components
import { Navbar, Nav, Container, Media } from "reactstrap";
import { State } from "../../Reducers/types";

import { setSession, setUserInfo } from "../../Reducers/User/userSlice";
import { getUserRole } from "../../Services/UserAuth/UserAuthenticate";
import LogOut from "../Modals/LogOut";
import Image from "../utils/Image";

interface TypeImage {
  full_url: string;
  thumbnails: ImageUrl[];
}

interface ImageUrl {
  dimension: string;
  url: string;
}

const AdminNavbar = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userInformation = useSelector((state: State) => state.user.userInfo);
  const [logoutModal, setLogoutModal] = useState(false);
  const logoutToggle = () => setLogoutModal(!logoutModal);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  // useEffect(() => {
  //   if (localStorage.getItem("UserInfo") && userInformation && getUserRole()) {
  //     const user_Info = localStorage.getItem("UserInfo") || "{}";
  //     const active_session = localStorage.getItem("session") || "{}";
  //     // fetchImageOfUser(JSON.parse(user_Info).avatar).then(
  //     //   (response: AxiosResponse) => {
  //     //     // console.log("Response for user image: ", response?.data?.data?.data);
  //     //     dispatch(setUserImageInfo(response?.data?.data?.data)); // store user image in store
  //     //     setUserImage(response?.data?.data?.data);
  //     //   }, (error) => {
  //     //     console.log("Error Caught: ", error?.response);
  //     //   }
  //     // ).catch(error => console.log("Error Catched ---> ", error));

  //     dispatch(setUserInfo(JSON.parse(user_Info))); // store user details in store
  //     dispatch(setSession(JSON.parse(active_session))); // store user details in store
  //   }
  // }, []);

  return (
    <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
      <Container fluid>
        {/* <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link> */}
        {/* <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input placeholder="Search" type="text" />
              </InputGroup>
            </FormGroup>
          </Form> */}
        <p className="text-white font-weight-bold text-uppercase">
          {props.brandText}
        </p>
        {/* <Button size="sm" onClick={() => history.goBack() }>Go BAck</Button> */}

        <Nav className="align-items-center d-none d-md-flex" navbar>
          {/* <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav> */}
          <Media className="align-items-center">
            <span className="avatar avatar-sm rounded-circle">
              <Image source={userInformation?.avatar_url || ""} />
            </span>
            <Media className="ml-2 d-none d-lg-block">
              <span className="mb-0 text-sm text-white font-weight-bold">
                {userInformation?.first_name} {userInformation?.last_name}
              </span>
            </Media>
          </Media>

          <i
            className="fas fa-sign-out-alt text-white ml-4 pointer"
            onClick={logoutToggle}
          ></i>

          <LogOut modalState={logoutModal} toggler={logoutToggle} />
          {/* </DropdownToggle> */}
          {/* <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/teacher/user-profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Settings</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-calendar-grid-58" />
                <span>Activity</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-support-16" />
                <span>Support</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={toggle}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
                <LogOut modalState={modal} toggler={toggle} />
              </DropdownItem>
            </DropdownMenu> */}
          {/* </UncontrolledDropdown> */}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
